import styled from "styled-components";

export const TaskContainerOuter = styled.div`
    background: #FFF;
    padding: 20px;
    border-radius: 10px;
    margin: 0 12px;
    box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
`;